import React from "react";
import { Heading, Stack, Text } from "@compono/ui";

/**
 * Gates an Interview Guides page on a precomputed permission boolean. When not
 * allowed, renders the app's standard "no permission" page (same copy as
 * candidate-search's ReadOnlyPage).
 *
 * The backend guide/bank READ queries are not role-scoped (any authenticated
 * org user can fetch them), so this is the frontend access boundary that keeps
 * Reviewers out of the guides list / question bank / editor and non-managers
 * out of the create wizard.
 */
export function GuideAccessGuard({
  allowed,
  children,
}: {
  allowed: boolean;
  children: React.ReactNode;
}) {
  if (!allowed) {
    return (
      <Stack align="center" sx={{ mt: 8 }} gap="4">
        <Heading level="3">
          You do not have permission to view this page
        </Heading>
        <Text>Please contact your administrator for access</Text>
      </Stack>
    );
  }
  return <>{children}</>;
}
